// extracted by mini-css-extract-plugin
export default {"CrumbContainer":"Crumb_CrumbContainer__MFE-K","CrumbTextContainer":"Crumb_CrumbTextContainer__3HSD5"};